<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        
        <div class="manager-title-custom">Chi tiết</div>
        
        <div class="mangader-name-custom">{{ name }}</div>
        
        <div class="f-grid adjust-border">
          
          <div class="the-info-box">
            
            <div class="the-box-part">
              <div class="flex-container-row">
                <div class="flex-item-left">
                  <label class="txt-left">Công ty:</label>
                </div>
                <div class="flex-item-right">
                  <div>{{ model?.company?.name }}</div>
                </div>
              </div>
              
              <div class="flex-container-row">
                <div class="flex-item-left">
                  <label class="txt-left">Loại khóa học:</label>
                </div>
                <div class="flex-item-right">
                  <div>{{ type_show }}</div>
                </div>
              </div>
            </div>

            <div class="the-box-part" v-if="lesson_id != null">
              <div class="flex-container-row">
                <div class="flex-item-left">
                  <label class="txt-left">Thời gian:</label>
                </div>
                <div class="flex-item-right">
                  <div>{{ time }}</div>
                </div>
              </div>

              <div class="flex-container-row">
                <div class="flex-item-left">
                  <label class="txt-left">Địa điểm:</label>
                </div>
                <div class="flex-item-right">
                  <div>{{ place }}</div>
                </div>
              </div>
            </div>

            <label class="txt-left">Risk topic</label>
            <div>{{ risk_topic }}</div>

          </div>

        </div>
        
        <div class="ckeditor-border adjust-border">
          <div v-html="description" class="ckeditor-custom"></div>
        </div>

        <Toolbar class="fixed-bottom-toolbar">
          <template slot="right">
            <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
            <Button
            v-if="this.$store.getters.controllers?.list_course && this.$store.getters.controllers?.list_course.includes('edit')"
            :label="$constants.TEXT_BUTTON.GOTOEDIT"
            @click="goToEdit()"
            class="p-button-success main-style-button" />
          </template>
        </Toolbar>

      </div>
    </div>
  </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";

export default {
  props: {
    users: Array,
  },
  data() {
    return {
      model: {},
      id : null,
      mode : 'view',
      name: "",
      type: "",
      type_show: "",
      risk_topic: "",
      description: "",
      lesson_id: null,
      time: "",
      place: "",
    };
  },
  async mounted() {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
      if(!this.$commonFuction.isEmpty(this.$route.query.lesson_id)){
        this.lesson_id = this.$route.query.lesson_id;
        if(this.lesson_id !== undefined){
          await this.getLessonData(this.lesson_id);
          this.time = this.model.lesson.time_text;
          this.place = this.model.lesson.address;
        }
      }
    }
    if (this.$route.params.id !== undefined) {
      this.id = this.$route.params.id;
      await this.getData(this.$route.params.id);
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
        this.name = this.model.name;
        this.type = this.model.type;
        this.risk_topic = this.model.risk_topic;
        this.description = this.model.description;
        if (this.type == "online") {
          this.type_show = "Online";
        } else {
          this.type_show = "Offline";
        }
      }
    }
    
  },

  watch: {},
  
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-course', query: {company_id: this.company_id} });
    },
    goToEdit() {
      const pageTransaction = (new Date()).getTime();
      localStorage.setItem(pageTransaction.toString(), JSON.stringify({ id: this.id, company_id: this.company_id }));
      this.$router.push({ path: `/admin/list-course/edit/${this.id}`, query: { page_transaction: pageTransaction.toString(), company_id: this.company_id } });
    },
    async getData(id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
        if(token){
            const headers = {
            "Authorization": "Bearer "+token,
            };
            var {data} = await ApiRepository.post("/_api/course/detail", {id: id, company_id: this.company_id}, {headers});
            var value = data.data;
            this.model = value;
        }
    },
    async getLessonData(lesson_id) {
      var token = this.$store.getters.token ? this.$store.getters.token : null;
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/course/detail_sra_course_lesson", {lesson_id: lesson_id, company_id: this.company_id}, {headers});
        var value = data.data;
        this.model.lesson = value;
      }
    },
  }
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
.mangader-name-custom {
 font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
 font-weight: bold;
 font-size: 24px;
 color: #0086c4;
 transform: TitleCase;
}
.the-info-box {
  background-color: #F8F9FB;
  border: #F3F4F7;
  margin: 10px 0px 10px 0px;
  padding: 10px;
  width: 100%;
}
.flex-container-row {
  display: flex;
  flex-wrap: wrap;
}
.flex-item-left {
  flex: 10%;
}
.flex-item-right {
  flex: 90%;
}
.the-box-part {
  margin: 0px 0px 10px 0px;
  padding: 10px 0px 10px 0px;
  border-bottom: 1px solid #EEEEEE;
}
.ckeditor-border {
  margin-left: auto;
  margin-right: auto;
  // width: 1084px; //tương đương với giới hạn width 1100px của ckeditor
}
.ckeditor-custom {
  max-width: 100%;
}
.ckeditor-custom img {
  max-width: 100%;
  height: auto;
}
.fixed-bottom-toolbar{background: transparent; border: 0 none; margin-top: 22px; border-top: 1px solid #B4B4B4; padding: 0; padding-top: 30px;
  .p-button{width: auto; margin-right: 8px;
    &:last-child{margin-right: 0;}
  }
}
figure.image_resized {
  margin: 0 auto;
}

figure.image-style-side {
  margin: 0 0 20px 20px;
  width: auto;
  float: right;
}

figure img {
  width: 100%; /* Makes the image take the full width of its parent element */
  height: auto; /* Maintains the image's aspect ratio */
}

</style>